<template>
  <div class="share-card-wrapper">
    <div v-if="!showBtn" class="share-card" ref="content">
      <img class="card-img" :src="data.pic" alt="">
      <div class="card-title">我是{{ data.title }}，编号{{ data.inner_id }}，正在参与{{ $store.state.voteInfo.title
        }}项目展示活动，快来帮我吧！
      </div>
      <div class="card-extra">
        <div class="card-qr" id="qrcode"></div>
      </div>
    </div>
    <img v-else class="card" :src="dataURL" alt="" @click="handleClick" crossorigin="anonymous">
    <div class="btn-download" v-if="showBtn" @click="handleClick">{{ tipText }}</div>
  </div>
</template>



<script>
import QRCode from "qrcodejs2";
import html2canvas from 'html2canvas'

export default {
  name: "",
  props: {
    data: Object,
    option: {
      type: Number | String,
    },
    activeTab: {
      type: Number | String,
    }
  },
  data() {
    return {
      qrcode: null,
      dataURL: null,
      showBtn: false,
      voteText: ''
    }
  },
  components: {
  },
  watch: {
    data: {
      handler(val) {
        console.log('shareCardData', shareCardData)
        // this.genQr()
        // this.genImg()
        // this.voteText = this.$store.state.voteText
      },
      deep: true
    }
  },
  computed: {
    isAPP() {
      let ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf("chuangqi") > -1 || window.ReactNativeWebView) {
        return true
      }
      return false
    },
    tipText() {
      return this.isAPP ? '点击查看并保存' : '长按图片保存'
    },
    // 1，投票组 0，普通投票
    type() {
      return this.$store.state.voteInfo.vote_list && this.data.state.voteInfo.vote_list.length ? 1 : 0;
    },
  },
  methods: {
    genQr() {
      let text
      let temp = window.location.href
      if (this.$utils.getUrlParams('option')) {
        text = `${temp.substring(0, temp.indexOf('option'))}option=${this.data.index}`
      } else {
        text = `${temp}&option=${this.data.index}`
      }
      // 投票组才加activceTab
      if (this.type) {
        text = `${text}&activeTab=${this.data.activeTab}`
      }
      console.log('shareCard 卡片url', text)
      console.log('shareCard 卡片url', encodeURIComponent(text))
      console.log('shareCard 卡片url', decodeURIComponent(encodeURIComponent(text)))
      const targetUrl = decodeURIComponent(encodeURIComponent(text))
      console.log('shareCard 卡片url 最终', targetUrl)
      this.qrcode = new QRCode(document.getElementById("qrcode"), {
        text: targetUrl,
        width: 100,
        height: 100,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    genImg() {
      const ref = this.$refs.content // 截图区域
      html2canvas(ref, {
        backgroundColor: '#ffffff',
        useCORS: true // 如果截图的内容里有图片,可能会有跨域的情况,加上这个参数,解决文件跨域问题
      }).then((canvas) => {
        this.dataURL = canvas.toDataURL('image/png')
        if (this.dataURL) {
          this.showBtn = true;
        }
      })
    },
    goBack() {
      this.$emit("close-pop");
    },
    handleClick() {
      if (this.isAPP) {
        this.$webBridgeApi.showImageViewer({
          images: [{ image: this.dataURL, title: "" }],
          index: 0,
        }).then(({ err, result }) => { });
      }
    }
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      console.log('shareCard data', this.data)
      console.log('this.$store.state', this.$store.state)
      this.voteText = this.$store.state.voteText;
      this.genQr();
      this.genImg();
    })
  }
}
</script>

<style scoped lang="less">
.share-card-wrapper {
  width: 6.2rem;
  height: 10rem;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;

  .share-card {
    width: 6.2rem;
    height: 8.3rem;
    border-radius: .2rem;
    padding: .25rem;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .card-img {
      max-width: 100%;
      max-height: 3.8rem;
    }

    .card-title {
      font-size: .3rem;
      color: #333;
      line-height: .5rem;
      margin-top: .2rem;
    }

    .card-extra {
      text-align: center;
      font-size: 0;
      margin-top: .4rem;

      .card-qr {
        display: inline-block;
        margin: 0 auto;
      }
    }

  }

  .card {
    width: 6.2rem;
    height: 8.3rem;
    border-radius: .2rem;
    pointer-events: all;
  }

  .btn-download {
    font-size: .3rem;
    color: #333;
    background-color: #fff;
    display: block;
    // width: 2.4rem;
    padding: 0 .5rem;
    height: .8rem;
    line-height: .8rem;
    margin: .2rem auto 0;
    border-radius: .1rem;
    text-align: center;
    font-weight: bold;
  }
}
</style>